<template>
  <div class="page flex-col">
    <div class="content flex-col">
      <img
        class="backBtn"
        @click="$router.back()"
        src="@/assets/icon/back.png"
      />
      <div class="top">
        <img class="logo" src="@/assets/icon/icon_bi2.png" />
        <img class="title" src="@/assets/icon/icon_sign_title.png" />
      </div>
      <img class="rules" src="@/assets/icon/icon_sign_rules.png" />
      <div class="calendar_box">
        <calendar
          :show-title="false"
          :poppable="false"
          :show-confirm="false"
          row-height=".9rem"
          readonly
          type="multiple"
          :min-date="dateRange[0]"
          :max-date="dateRange[1]"
          :default-date="allSignDate"
          :style="{ height: '6.41rem' }"
        />
      </div>
      <div class="signInfo">
        <div class="title">
          已连续签到<span>{{ running_days }}</span
          >天
        </div>
        <div class="tip">连续签到10天,即可获得10枚五行币。</div>
        <div class="progress-box">
          <div class="progress-top">
            <div>10枚五行币</div>
          </div>
          <div class="progress">
            <Vprogress
              :percentage="signProgress"
              stroke-width="8"
              class="striped-progress animated-stripes purple-stripes"
            />
          </div>
          <div class="progress-bottom">
            <span>1天</span>
            <span>2天</span>
            <span>3天</span>
            <span>4天</span>
            <span>5天</span>
            <span>6天</span>
            <span>7天</span>
            <span>8天</span>
            <span>9天</span>
            <span>10天</span>
          </div>
        </div>
      </div>
      <div class="btn" @click="signBtn">
        <span v-if="isSign">{{ $t("sign.success") }}</span>
        <span v-else>{{ $t("sign.signIn") }}</span>
      </div>
    </div>
    <overlay :show="showSignSuccess" @click="showSignSuccess = false">
      <div style="display: flex; align-items: center; justify-content: center; height: 100%;">
        <img style="width: 6rem;" src="@/assets/images/signSuccess.png"/>
      </div>
    </overlay>
  </div>
</template>

<script>
const BIG_MONTH = [1, 3, 5, 7, 8, 10, 12];
const SMALL_MONTH = [4, 6, 9, 11];

function getDaysFromCurrentMonth(year, month) {
  if (BIG_MONTH.indexOf(month) !== -1) {
    return 31;
  }

  if (SMALL_MONTH.indexOf(month) !== -1) {
    return 30;
  }

  if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
    return 29;
  }

  return 28;
}

function getWeekdayOfMonth(year, month) {
  const fistDate = new Date(year, month - 1, 1);
  return fistDate.getDay();
}

function isObject(obj) {
  return Object.prototype.toString.call(obj) === "[object Object]";
}

function getRewardSetList(obj) {
  if (isObject(obj)) {
    return Object.keys(obj).map((key) => {
      return {
        value: obj[key].value,
        type: obj[key].type,
        day: key,
        id: obj[key].id,
        getstatus: obj[key].getstatus,
      };
    });
  }

  return [];
}

import Vue from "vue";
import SignProcess from "../../components/signProcess";
import Fetch from "../../utils/fetch";
import { Dialog } from "vant";

import { Calendar, Progress,Overlay } from "vant";
export default {
  name: "Jz",
  components: {
    SignProcess,
    Calendar,
    Vprogress: Progress,
    Overlay,
  },
  data() {
    return {
      data: {},
      signData: {},
      running_days: 0,
      show_down: false,
      title: "",
      isSign: false,
      placeholderEleCount: 0,
      allDays: 0,
      reward_set_list: [],
      award_tips: "",
      award_num: "",
      signShow: false,
      year: null, //年份
      month: null, //月份
      showSignSuccess:false
    };
  },
  computed:{
    dateRange(){
      const now=new Date()
      // 当月第一天（00:00:00）
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);

      // 当月最后一天（23:59:59）
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      return [firstDay,lastDay]
    },
    signProgress(){
      if(this.running_days<10){
        return this.running_days*10;
      }else{
        return 100;
      }
    },
    allSignDate(){
      if(!this.allDays){return []}
      console.log(this.allDays.filter(v=>v.is_signin==1).map(v=>new Date(v.date)))
      return this.allDays.filter(v=>v.is_signin==1).map(v=>new Date(v.date.replace(/-/g,'/')))
    }
  },
  created() {
    this.$parent.footer("user", false);
    let today = new Date();
    this.year = today.getFullYear();
    this.month = today.getMonth() + 1;
  },
  mounted() {
    this.init();
  },
  methods: {
    signBtn() {
      Fetch("/user/sign").then((r) => {
		    this.showSignSuccess=true
        this.signShow = true;
        this.running_days = r.data.days;
        this.isSign = true;
        this.award_tips = this.$t("sign.cash");
        this.award_num = r.data.reward_num;
        this.init();
      });
    },
    init() {
      Fetch("/user/sign_log").then((r) => {
        this.allDays = r.data.date_list;
      });

      // 累计奖励列表
      Fetch("/user/sign_reward").then((r) => {
        var reward_set = {};
        r.data.reward_list.forEach((item) => {
          reward_set[item.days] = {
            type: item.reward_type == 2 ? "djq" : "hb",
            value: item.reward_num,
            getstatus: item.can_draw,
            id: item.id,
          };
        });
        this.running_days = r.data.signin_days;
        this.isSign = r.data.isSign;
        this.reward_set_list = getRewardSetList(reward_set);
        this.signData = r.data.today_reward;
      });
      let today = new Date();

      const year = today.getFullYear();
      const month = today.getMonth() + 1;

      // const days = getDaysFromCurrentMonth(year, month)
      this.title = `${year}-${month}`;
      // this.allDays = getDaysFromCurrentMonth(year, month)
      this.placeholderEleCount = getWeekdayOfMonth(year, month);
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  position: relative;
  width: 10rem;
  overflow: hidden;
  .content {
    position: relative;
    width: 10rem;
    height: 100vh;
    background: url(~@/assets/sign_bg.png) 100% no-repeat;
    background-size: 10rem 100%;
    background-position: top center;
    padding-top: 0.1px;
    .backBtn {
      position: fixed;
      width: 0.27rem;
      height: 0.47rem;
      top: 1rem;
      left: 0.3rem;
    }
    .top {
      margin-top: 1.2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      .logo {
        width: 1.96rem;
        margin-right: 0.75rem;
      }
      .title {
        width: 3.5rem;
      }
    }
    .rules {
      width: 8.6rem;
      margin: 0.75rem 0.7rem 0 0.7rem;
    }
    .calendar_box {
      width: 8.63rem;
      height: 6.41rem;
      background: #ffffff;
      border-radius: 0.27rem;
      margin: 0.3rem 0.7rem 0 0.7rem;
      /deep/.van-calendar__body {
        overflow: hidden !important;
        color: #888888 !important;
      }
      /deep/.van-calendar__header {
        box-shadow: none;
        padding-top: 0.2rem;
        color: #888888 !important;
      }
      /deep/.van-calendar__header-subtitle {
        display: none !important;
      }
      /deep/.van-calendar__selected-day,/deep/.van-calendar__day--end,/deep/.van-calendar__day--start,/deep/.van-calendar__day--multiple-middle {
        width: 0.76rem !important;
        height: 0.76rem !important;
        background: #fb965a;
        border-radius: 50%;
        margin: 0 calc(7.1425% - .38rem);
      }
    }
    .signInfo {
      width: 8.52rem;
      height: 2.64rem;
      background: #ffffff;
      border-radius: 0.35rem;
      margin: 0.3rem 0.7rem 0 0.7rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      .title {
        color: #fda353;
        font-size: 0.5rem;
        font-weight: bold;
        display: flex;
        align-items: center;
        span {
          font-size: 1.1rem;
          color: #f8855e;
        }
      }
      .tip {
        color: #fda353;
        font-size: 0.28rem;
        font-weight: bold;
      }
      .progress-box {
        width: 6.6rem;
        position: relative;
        margin-top: 0.6rem;
        .progress-top {
          display: flex;
          justify-content: flex-end;
          div {
            color: #fff;
            background: linear-gradient(180deg, #fda353, #f8855e);
            width: 1.44rem;
            padding: 0 0.1rem;
            height: 0.32rem;
            line-height: 0.32rem;
            font-size: 0.24rem;
            border-radius: 0.2rem;
            position: relative;
            margin-top: -0.5rem;
            &::after {
              content: "";
              position: absolute;
              bottom: -0.16rem;
              right: 0.3rem;
              width: 0;
              height: 0;
              border-left: 0.1rem solid transparent;
              border-right: 0.1rem solid transparent;
              border-top: 0.16rem solid #fda353;
            }
          }
        }
        .progress {
          /deep/.van-progress__pivot {
            display: none;
          }
          /deep/.van-calendar__day--end,/deep/.van-calendar__day--start,/deep/.van-calendar__day--multiple-middle {
            background-image: linear-gradient(
                45deg,
                rgba(255, 255, 255, 0.15) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.15) 50%,
                rgba(255, 255, 255, 0.15) 75%,
                transparent 75%,
                transparent
            );
			background-color: #fda353;
            background-size: 16px 16px;
          }
        }
        .progress-bottom {
          margin-top: 0.1rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          span {
            display: inline-flex;
            font-size: 0.2rem;
            color: #fda353;
          }
        }
      }
    }
    .btn {
      width: 8.52rem;
      height: 1.03rem;
      background: linear-gradient(180deg, #fda353, #f8855e);
      border-radius: 0.51rem;
      margin: 0.2rem 0.7rem 0 0.7rem;
      font-family: SourceHanSansCN;
      font-weight: 800;
      font-size: 0.37rem;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
